export default function ({ store, $axios, app }) {
  // $axios.setBaseURL(process.env.VUE_APP_ROOT_API)

  $axios.interceptors.request.use((config) => {
    const locale = app.i18n.locale
    if (locale) {
      $axios.setHeader('Accept-Language', locale)
    }
    return config
  })

  $axios.interceptors.response.use(
    response => {
      // Manejar la respuesta exitosa
      return response;
    },
    error => {
      let user = null;
      if (app.$auth && app.$auth.loggedIn) {
        user = {
          id: app.$auth.user.id,
          email: app.$auth.user.email
        };
      }

      if (!error.response) {
        // Manejar "Network Error"
        app.$logger.error('🔴 Network Error: Unable to connect to the API', { error, user });
      }

      // Devolver el error para que pueda ser manejado por las promesas
      return Promise.reject(error);
    }
  )
}
